import { $authHost } from "./index";

export const createReport = async (reportId) => {
  const data = await $authHost.get("/api/reports/getReportData/xml/" + reportId, {
    responseType: "blob", // Set the response type to 'blob' for file downloads
  });

  return data;
};

export const generateReport = async (info) => {
  const data = await $authHost.post("/api/reports/generate", info, {});

  return data
}

export const getByContract = async (contractId) => {
  const {data} = await $authHost.get("/api/reports/byContract/" + contractId);

  return data;
}

export const getReportData = async (reportId) => {
  const {data} = await $authHost.get("/api/reports/getReportData/" + reportId);

  return data;
}

export const deleteReport = async (reportId) => {
  const {data} = await $authHost.delete("/api/reports/" + reportId);

  return data;
}